import(/* webpackMode: "eager" */ "/home/runner/work/landing-maps-posgrados/landing-maps-posgrados/src/app/page.js");
